/** The included runs plus the on-demand limit, the included runs when pausing without one, or null for no limit. */
export function getWorkflowRunLimit(includedRuns, { workflowRuns: { onDemandLimit }, pauseAtLimit }) {
    if (onDemandLimit !== null) {
        return includedRuns + onDemandLimit;
    }
    return pauseAtLimit ? includedRuns : null;
}
//# sourceMappingURL=usage-limits.js.map